"use client"

// src/components/list.ts
var List = {
  baseStyle: {
    container: {},
    icon: {
      display: "inline-block",
      me: "2",
      verticalAlign: "middle"
    },
    item: {}
  }
};

export {
  List
};
//# sourceMappingURL=chunk-WXUQWH66.mjs.map